import { type Reducer } from "redux";
import {
  ADD_MANAGED_ACCOUNT,
  SET_ACCOUNT_TO_DISPLAY,
  SET_MANAGED_ACCOUNTS,
  SET_MASTER_TOKEN,
  SET_SHIPPING_ADDRESS
} from "../actions/user";
import type ManagedAccount from "@tootsweet/model/entities/ManagedAccount";

export interface UserStateI {
  masterToken?: string;
  managedAccounts: ManagedAccount[];
  accountToDisplay?: ManagedAccount;
  accountToDisplayIndex: number;
}

const initialState: UserStateI = {
  managedAccounts: [],
  accountToDisplayIndex: -1
};

const userReducer: Reducer<UserStateI> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case SET_MASTER_TOKEN:
      return {
        ...state,
        masterToken: action.masterToken
      };
    case SET_MANAGED_ACCOUNTS:
      return {
        ...state,
        managedAccounts: action.managedAccounts
      };
    case ADD_MANAGED_ACCOUNT:
      // console.log("ADD_MANAGED_ACCOUNT", action?.managedAccount?.trackingID);
      return {
        ...state,
        managedAccounts: [...state.managedAccounts, action.managedAccount]
      };
    case SET_ACCOUNT_TO_DISPLAY:
      // console.log(
      //   "SET_ACCOUNT_TO_DISPLAY",
      //   action?.accountToDisplay?.trackingID
      // );
      return {
        ...state,
        accountToDisplay: action.accountToDisplay,
        accountToDisplayIndex: state.managedAccounts.findIndex(
          (ma) =>
            !!action.accountToDisplay &&
            ma.trackingID === action.accountToDisplay.trackingID
        )
      };
    case SET_SHIPPING_ADDRESS:
      const newManagedAccounts = [...state.managedAccounts];
      const managedAccount = newManagedAccounts.find(
        (ma) => ma.trackingID === action.trackingID
      );
      if (managedAccount?.businessUser) {
        managedAccount.businessUser.shippingAddress = action.address;
      }
      return {
        ...state,
        managedAccounts: newManagedAccounts
      };
  }
  return state;
};

export default userReducer;
